document.addEventListener('DOMContentLoaded', function() {
  // Select all OwlCarousel elements on the page
  const carousels = document.querySelectorAll('.owl-carousel');
  
  // Loop through each carousel instance
  carousels.forEach(function(owlCarousel) {
    // Get settings from data attributes
    const autoplayTimeout = owlCarousel.getAttribute('data-autoplay-timeout');
    const loop = owlCarousel.getAttribute('data-loop') === 'true';
    const autoplay = owlCarousel.getAttribute('data-autoplay') === 'true';
    const nav = owlCarousel.getAttribute('data-nav') === 'true';
    const dots = owlCarousel.getAttribute('data-dots') === 'true';
    const itemsDesktop = owlCarousel.getAttribute('data-items-desktop');
    const itemsTablet = owlCarousel.getAttribute('data-items-tablet');
    const itemsMobile = owlCarousel.getAttribute('data-items-mobile');

    // Initialize OwlCarousel for each instance
    $(owlCarousel).owlCarousel({
      autoplayTimeout: parseInt(autoplayTimeout, 10),
      loop: loop,
      autoplay: autoplay,
      nav: nav,
      navText: ["<span class='owl-prev'>&#10094;</span>", "<span class='owl-next'>&#10095;</span>"],
      dots: dots,
      margin: 20,
      responsive: {
        0: {
          items: parseInt(itemsMobile, 10)
        },
        600: {
          items: parseInt(itemsTablet, 10)
        },
        1000: {
          items: parseInt(itemsDesktop, 10)
        }
      }
    });
 
  });
});